import { useState, useEffect } from 'react';
import axios from 'axios';
import { fetchLiturgicalEventsByDate } from '../utilities/api';

const useLiturgicalEvents = (year, month, day) => {
  
  const [isLoading, setIsLoading] = useState(true);
  const [eventData, setEventData] = useState(null);

  useEffect(() => {
    if (!year || !month || !day) return;
    console.log("Fetching liturgical events for:", year, month, day);
    
    const controller = new AbortController();
    const signal = controller.signal;

    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = await fetchLiturgicalEventsByDate(year, month, day, signal);
        setEventData(data);
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log("API request canceled:", error.message);
          return{};
        } else {
          console.error("Error fetching liturgical events:", error);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();

    return () => {
      controller.abort();
    };
  }, [year, month, day]); // Refetch when date changes

  return { isLoading, eventData };
};

export default useLiturgicalEvents;
